<template>
    <div class="headerTopArea">
        <div class="container">
            <div class="row">
                <!--<div class="col-md-5 col-sm-3 col-xs-5">-->
                <!--<div class="langOpt">-->
                <!--<span class="langTxt">Language: &nbsp;</span>-->
                <!--<span class="langIcon"><span class="langCode">en</span><i class="icofont icofont-caret-down"></i> </span>-->
                <!--<ul class="lang">-->
                <!--<li data-code="en">english</li>-->
                <!--<li data-code="bn">bengali</li>-->
                <!--<li data-code="ar">aribic</li>-->
                <!--<li data-code="da">dansk</li>-->
                <!--</ul>-->
                <!--</div>-->
                <!--</div>-->
                <div class="col-md-7 col-sm-9 col-xs-7 col-md-offset-5 col-sm-offset-3 col-xs-offset-5">
                    <ul class="topInfo">
                        <li class="call">
                            <a :href="'tel:'+ company.tel">
                                <i class="icofont icofont-ui-call"></i>{{ company.tel }}
                            </a>
                        </li>
                        <li class="email">
                            <a :href="'mailto:' + company.email">
                                <i class="icofont icofont-ui-v-card"></i>{{ company.email }}
                            </a>
                        </li>
                        <li class="clientAreaLi">
                            <a class="log" :href="settings.app_url + '/login'">
                                <i class="icofont icofont-user-alt-3"></i>
                                Entrar
                            </a>
                        </li>
                    </ul>
                    <!--<div class="clientLogin">-->
                    <!--<form action="login.php" method="post">-->
                    <!--<div class="closeBtn"><i class="icofont icofont-close"></i></div>-->
                    <!--<div class="h5">sign in</div>-->
                    <!--<div class="userName"><input name="userName" placeholder="Username" type="text"></div>-->
                    <!--<div class="password"><input name="password" placeholder="Password" type="password"></div>-->
                    <!--<input type="submit" value="sign in">-->
                    <!--<div class="h5">Forgot Passsword? <a href="#">Click here</a></div>-->
                    <!--<div class="logBtm">-->
                    <!--<div class="h5">Don’t have an account yet?</div>-->
                    <!--<a href="#" class="signUp">Click here to sign up.</a>-->
                    <!--</div>-->
                    <!--</form>-->
                    <!--</div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Company from '@/database/company.json'
import Settings from '@/database/settings.json'

export default {
  name: 'site-top-bar',
  data () {
    return {
      company: Company,
      settings: Settings
    }
  }
}
</script>

<style scoped>
    .v2 header .topInfo li.clientAreaLi a {
        background: #2080d8;
        padding: 0 25px;
        color: #fff;
    }

    .v2 header .topInfo li.clientAreaLi a:hover {
        background: rgba(80, 168, 235, 0.79);
    }
</style>



// WEBPACK FOOTER //
// src/components/site/SiteTopBar.vue